module.exports = __webpack_public_path__ + "ba58cf6fe06366a59635ff445b514dc0.png";